import './App.css';
import { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import SearchResults from './SearchResults';

function App() {
  const [searchQuery, setSearchQuery] = useState('');
  const [centerSearchQuery, setCenterSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    const query = searchQuery.trim() || 'all';

    // Navigate to search results page with query parameters
    navigate(`/works/search?q=${encodeURIComponent(query)}&sortby=submittedDate&sortOrder=descending`);
  };

  const handleCenterSearch = async (e) => {
    e.preventDefault();
    const query = centerSearchQuery.trim() || 'all';

    // Navigate to search results page with query parameters
    navigate(`/works/search?q=${encodeURIComponent(query)}&sortby=submittedDate&sortOrder=descending`);
  };

  const handleBackToHome = () => {
    setSearchQuery('');
    setCenterSearchQuery('');
  };


  return (
    <div className="App">
      {/* Header with Navigation */}
      <header id="header">
        {/* White Title Section */}
        <div className="header-title">
          <h1 id="sitename">
            <a href="/" onClick={(e) => { e.preventDefault(); handleBackToHome(); navigate('/'); }}>Rxiv of Our Own (deployed)</a>
          </h1>
        </div>

        {/* Red Navigation & Search Section */}
        <div className="header-inner">
          <nav className="primary">
            <ul className="navigation">
              <li><a href="#fandoms">Fandoms</a></li>
              <li><a href="#browse">Browse</a></li>
              <li><a href="#search">Search</a></li>
              <li><a href="#about">About</a></li>
            </ul>
          </nav>

          {/* Inline Search Bar */}
          <form className="header-search" method="get" onSubmit={handleSearch}>
            <input
              type="text"
              id="header_search_query"
              name="q"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <input type="submit" value="Search" className="search-button" />
          </form>
        </div>
      </header>

      {/* Main Content */}
      <main id="main">
        <Routes>
          <Route path="/" element={
            <div className="homepage">
              <section className="two-columns">
                <div className="column">
                  <h2>Find Your Favourites</h2>
                  <ul>
                    <li>  Physics</li>
                    <li>  Mathematics</li>
                    <li>  Computer Science</li>
                    <li>  Quantitative Biology</li>
                    <li>  Quantitative Finance</li>
                    <li>  Statistics </li>
                    <li>  Electrical Engineering and Systems Science</li>
                    <li>  Economics</li>
                  </ul>
                </div>
                <div className="column">
                  <h2>Welcome to Rxiv of Our Own</h2>
                  <p>arXiv is a free distribution service and an open-access archive for nearly 2.4 million scholarly articles in the fields of physics, mathematics, computer science, quantitative biology, quantitative finance, statistics, electrical engineering and systems science, and economics. Materials on this site are not peer-reviewed by arXiv.</p>
                </div>
              </section>
              <section className="center-search-section">
                <form className="center-search" method="get" onSubmit={handleCenterSearch}>
                  <input
                    type="text"
                    id="center_search_query"
                    name="q"
                    placeholder="Search papers..."
                    value={centerSearchQuery}
                    onChange={(e) => setCenterSearchQuery(e.target.value)}
                    className="center-search-input"
                  />
                  <input type="submit" value="Search" className="center-search-button" />
                </form>
              </section>
            </div>
          } />
          <Route path="/works/search" element={<SearchResults />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer id="footer">
        <ul className="footer-navigation">
          <li>
            <h4>About</h4>
            <ul>
              <li><a href="#about">About the rxiv</a></li>
              <li><a href="#site-map">Site Map</a></li>
              <li><a href="#diversity">Diversity Statement</a></li>
              <li><a href="#content">Content Policy</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#dmca">DMCA Policy</a></li>
            </ul>
          </li>
          <li>
            <h4>Contact us</h4>
            <ul>
              <li><a href="#help">Help & Support</a></li>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </li>
        </ul>
        <p className="copyright">
          <p>Thank you to arXiv for use of its open access interoperability. This service was not reviewed or approved by, nor does it necessarily express or reflect the policies or opinions of, arXiv.</p>
          <br />
          <a href="https://opensource.org/license/mit">MIT License</a>
          <br />
        </p>
      </footer>
    </div>
  );
}

export default App;
